// extracted by mini-css-extract-plugin
export default {"split":"sidebar_split__nsgNa","active":"sidebar_active__yGXOm"};